import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const MessageIcon = (props: IIconProps) => {
  const { width = 24, height = 24, color = 'currentColor' } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.0083 5.25342H21.0087V18.0037C21.0087 18.2026 20.9296 18.3934 20.789 18.534C20.6483 18.6747 20.4576 18.7537 20.2586 18.7537H3.75832C3.5594 18.7537 3.36863 18.6747 3.22798 18.534C3.08732 18.3934 3.0083 18.2026 3.0083 18.0037V5.25342Z" stroke={color} strokeWidth="1.50003" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21.0087 5.25342L12.0085 13.5036L3.0083 5.25342" stroke={color} strokeWidth="1.50003" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default memo(MessageIcon);
